export const HBErrCode = {
  verify: 555,
  notLogin: 401,
};

// https://doc.huanleguang.com/pages/viewpage.action?pageId=382901556
export enum GDErrCode {
  /**用户不在租户里 */
  UserNotInOrg = "10010412",
  /**未绑定租户 */
  UnBindOrg = "10010413",
  /** 空间容量不足 */
  SpaceFull = "36002105",
  /** token 失效*/
  InvalidAccessToken = "1002005",
  /** invalid_access_token_expire*/
  InvalidAccessTokenExpire = "1002015",

  // 需要重新登录
  /** 登录设备数量超过限制 */
  OtherDeviceLogin = "1002023",
  /**invalid_authorization_code */
  InvalidAuthorizationCode = "1002003",
  /**authorization_code_expired */
  AuthorizationCodeExpired = "1002004",
  /**invalid_refresh_token */
  InvalidRefreshToken = "1002013",
  /**invalid_refresh_token_expire */
  InvalidRefreshTokenExpire = "1002014",
}

/**
 * 需要重新登录的错误码
 */
export const NeedReLoginCodes = [
  GDErrCode.OtherDeviceLogin,
  GDErrCode.InvalidAuthorizationCode,
  GDErrCode.AuthorizationCodeExpired,
  GDErrCode.InvalidRefreshToken,
  GDErrCode.InvalidRefreshTokenExpire,
];

/**
 * access token 失效的错误码
 */
export const TokenExpiredCodes = [
  GDErrCode.InvalidAccessToken,
  GDErrCode.InvalidAccessTokenExpire,
];
